import { MenuCounter } from "@bokio/components/Menu/components/MenuCounter/MenuCounter";
import { useTodoStatus } from "@bokio/shared/state/requests";

import type { CounterBadgeColor } from "../CounterBadge/CounterBadge";
import type { ToDoCounterType } from "@bokio/components/Menu/components/MenuCounter/MenuCounter";
import type { FC } from "react";

interface TodoMenuCounterProps {
	companyId: string;
	type: ToDoCounterType;
	color: CounterBadgeColor;
}

const TodoMenuCounter: FC<TodoMenuCounterProps> = ({ type, color }) => {
	const { todoCount } = useTodoStatus();
	if (!todoCount || todoCount.ToDoTotalCount === 0) {
		return null;
	}

	return (
		<MenuCounter color={color} type={type} animateOnCountValueChange count={todoCount} testId="Menu_Todo_Counter" />
	);
};

export default TodoMenuCounter;
